import React from 'react';
import Modal from 'react-modal';

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(4, 7, 12, 0.92)',
    zIndex: 2000,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: 0,
    transform: 'translate(-50%, -50%)',
    padding: 0,
    borderRadius: '20px',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    background: 'transparent',
    overflow: 'visible',
    maxWidth: 'calc(100vw - 16px)',
    maxHeight: 'calc(100vh - 16px)',
    boxShadow: '0 26px 50px rgba(0, 0, 0, 0.35)',
  }
};

Modal.setAppElement(document.getElementById('root'));

function CustomModal(props) {
  return (
    <Modal
    isOpen={props.visible}
    onRequestClose={props.closeModal}
    style={customStyles}>
      <div className={`customModal ${props.className || ''}`.trim()} style={props.styles ? { ...props.styles } : {}}>
        {props.children}
      </div>

  </Modal>
  );
}

export default CustomModal;
